'use client'

// src/context/search/useSearch.ts
import { useContext } from "react";

// src/context/search/context.tsx
import { createContext } from "react";
var SearchContext = createContext({
  searchHistory: [],
  showPopover: false,
  category: "",
  togglePopover: () => {
  },
  onSearch: () => {
  },
  setCategory: () => {
  },
  setDate: () => {
  },
  onSubmit: () => {
  },
  clearAll: () => {
  },
  clearHistory: () => {
  },
  isLoading: false
});
var context_default = SearchContext;

// src/context/search/useSearch.ts
function useSearch() {
  const context = useContext(context_default);
  return context;
}

export {
  context_default,
  useSearch
};
//# sourceMappingURL=chunk-WOKBAUXU.mjs.map